import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    emptyListTitle: string;
    emptyListCta: string;
    learnMore: string;
    translationUnavailable: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Sheet title shown at the top of the "What's New" panel */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WhatsNewSheet.title?c=yzvxazr24avq", defaultMessage: "What\u2019s New" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Empty state title shown when there are no "What's New" items to display */
            emptyListTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WhatsNewSheet.emptyListTitle?c=o06kou7jgrms", defaultMessage: "No news available" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Empty state call-to-action label for viewing all items */
            emptyListCta: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WhatsNewSheet.emptyListCta?c=2h9v6y3py76t3", defaultMessage: "View All" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Link text for opening the full "What's New" item in a new tab */
            learnMore: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WhatsNewSheet.learnMore?c=2bu5tw74q9bww", defaultMessage: "Learn more" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Banner text for when translations are not yet available */
            translationUnavailable: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WhatsNewSheet.translationUnavailable?c=239nt3kgv95gg", defaultMessage: "Articles are currently available in English only. Additional languages will be available soon." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
